<template>
  <div class="fill-height d-flex flex-column flex-grow-1">
    <h2 class="mb-5">Garancija GSV - PWA</h2>
    {{ cr }}
    <p>
      PWA je spletna aplikacija, ki se da instalirat na računalnik ali mobilno
      napravo.<br />
      Zato je aplikacija zelo odzivna, preko spleta se po instalaciji prenašajo
      samo podatki in ne več celi ekrani.
    </p>
  </div>
</template>

<script>
export default {
  computed: {
    cr() {
      return this.$route.name;
    },
  },
};
</script>
